/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_CreateInputs */

const en_admin_posts_create = /** @type {(inputs: Admin_Posts_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Post`)
};

/**
* | output |
* | --- |
* | "Create Post" |
*
* @param {Admin_Posts_CreateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_create = /** @type {((inputs?: Admin_Posts_CreateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_CreateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_create(inputs)
});
export { admin_posts_create as "admin.posts.create" }